import React from "react";

import "./Profil.css";
import "./Profil.mobile.css";


const profileInfosData = {
    identity: {
        firstName: "Dimitri",
        lastName: "Youla",
        role: "Développeur & Consultant Digital"
    },

    photo: {
        src: "https://placehold.co/400x400/080808/F4F1EA?text=DY",
        alt: "Dimitri Youla"
    },

    links: [
        {
            label: "GitHub",
            url: "https://github.com/QnYosa",
            type: "github"
        },
        {
            label: "LinkedIn",
            url: "https://www.linkedin.com/in/dimitri-youla-5697aa104",
            type: "linkedin"
        },
        {
            label: "Email",
            url: "mailto:dimitriyoula@gmail.com",
            type: "email"
        }
    ]
};


const servicesData = [
    {
        title: "Automatisation & IA",
        description:
            "Automatisation de tâches répétitives, création de workflows intelligents et pipelines IA."
    },
    {
        title: "Conseil & Stratégie",
        description:
            "Accompagnement dans les choix techniques et définition des priorités stratégiques."
    },
    {
        title: "Simplification process",
        description:
            "Optimisation des processus existants et réduction des frictions opérationnelles."
    },
    {
        title: "Traduction technique",
        description:
            "Adaptation de contenus complexes et localisation pour un public international."
    },
    {
        title: "Développement web",
        description:
            "Création d'outils sur mesure, applications web et intégrations d'APIs."
    },
    {
        title: "Data & Scraping",
        description:
            "Collecte de données structurées et veille concurrentielle automatisée."
    },
    {
        title: "Content Automation",
        description:
            "Génération automatisée de contenus et optimisation des flux de diffusion."
    },
    {
        title: "Business Partner",
        description:
            "Aide au lancement de projets et mise en place de structures scalables."
    },
    {
        title: "Support Technique",
        description:
            "Maintenance, débogage et amélioration continue des systèmes en place."
    },
    {
        title: "Formation",
        description:
            "Coaching pour gagner en autonomie sur l'IA et les outils numériques."
    }
];


const objectivesData = {
    profil: {
        title: "Profil",

        text: `Développeur polyglotte, j'interviens là où la complexité ralentit les décisions et freine les projets.

Je transforme des problématiques techniques en solutions claires, structurées et mesurables. Audit, analyse stratégique, optimisation d'infrastructure : j'identifie ce qui fonctionne, ce qui bloque et surtout ce qui peut être simplifié pour accélérer l'exécution, réduire les frictions et améliorer la performance globale.

J'accompagne également la refonte de processus afin de les rendre plus fluides et plus cohérents, en intégrant l'intelligence artificielle uniquement lorsqu'elle apporte un gain réel en temps, en efficacité ou en qualité.

Ce qui me distingue, c'est ma capacité à faire le lien entre vision stratégique et réalité technique. Je ne me contente pas de développer : j'analyse, j'anticipe et je structure pour que chaque décision soit compréhensible, pertinente et durable.

Mon objectif est simple : créer des systèmes plus intelligents, plus efficaces et capables d'évoluer avec vos ambitions.`
    }
};


const profileParagraphs =
    objectivesData.profil.text
        .split("\n\n")
        .filter(Boolean);


const tickerItems =
    servicesData.map(
        (service) => service.title
    );


/* ============================================================
   TICKER
   ============================================================ */

const TickerBanner = () => {

    const doubledItems = [
        ...tickerItems,
        ...tickerItems
    ];


    return (
        <div
            className="profil-ticker-banner"
            aria-hidden="true"
        >

            <div className="profil-ticker-track">

                {doubledItems.map(
                    (item, index) => (

                        <span
                            key={index}
                            className="profil-ticker-item"
                        >

                            {item}

                            <span className="profil-ticker-sep">
                                ◆
                            </span>

                        </span>

                    )
                )}

            </div>

        </div>
    );
};


/* ============================================================
   PROFILE MANIFESTO
   ============================================================ */

const ProfileManifesto = () => (

    <section className="profil-objectives-block">

        <header className="profil-objectives-heading">

            <h2 className="profil-objectives-title">
                {objectivesData.profil.title}
            </h2>

        </header>


        {/* =====================================================
            DESKTOP
            ===================================================== */}

        <div className="profil-objectives-desktop">

            {profileParagraphs.map(
                (paragraph, index) => (

                    <p key={index}>
                        {paragraph}
                    </p>

                )
            )}

        </div>


        {/* =====================================================
            MOBILE
            ===================================================== */}

        <div className="profil-objectives-mobile">

            <p className="profil-objectives-intro">
                {profileParagraphs[0]}
            </p>


            <details className="profil-objectives-details">

                <summary>
                    <span>
                        Lire le profil complet
                    </span>
                </summary>


                <div className="profil-objectives-expanded">

                    {profileParagraphs
                        .slice(1)
                        .map(
                            (paragraph, index) => (

                                <p key={index}>
                                    {paragraph}
                                </p>

                            )
                        )}

                </div>

            </details>

        </div>

    </section>

);


/* ============================================================
   LINKS
   ============================================================ */

const ProfileLinks = () => (

    <nav
        className="profil-links-nav"
        aria-label="Liens professionnels"
    >

        <ul className="profil-links">

            {profileInfosData.links.map(
                (link) => (

                    <li key={link.type}>

                        <a
                            href={link.url}
                            className="profil-link"
                        >

                            <span
                                className="profil-link-arrow"
                                aria-hidden="true"
                            >
                                →
                            </span>


                            <span className="profil-link-label">
                                {link.label}
                            </span>


                            <span
                                className="profil-link-open"
                                aria-hidden="true"
                            >
                                ↗
                            </span>

                        </a>

                    </li>

                )
            )}

        </ul>

    </nav>

);


/* ============================================================
   SERVICE CARD
   ============================================================ */

const ServiceCard = ({
    service,
    index
}) => (

    <article className="profil-service-card">

        <header className="profil-service-card-header">

            <span className="profil-service-number">
                {String(index + 1).padStart(2, "0")}
            </span>


            <h3 className="profil-service-title">
                {service.title}
            </h3>

        </header>


        <div className="profil-service-card-body">

            <p className="profil-service-description">
                {service.description}
            </p>


            <span className="profil-service-marker">
                EXPERTISE
            </span>

        </div>

    </article>

);


/* ============================================================
   PROFIL
   ============================================================ */

const Profil = () => (

    <section
        className="profil-container"
        aria-labelledby="profil-services-title"
    >

        {/* =====================================================
            HERO
            ===================================================== */}

        <header className="profil-hero">


            {/* =================================================
                IDENTITY
                ================================================= */}

            <div className="profil-identity-panel">

                <img
                    src={profileInfosData.photo.src}
                    alt={profileInfosData.photo.alt}
                    className="profil-photo"
                />


                <div className="profil-identity-content">

                    <h1 className="profil-name">

                        {profileInfosData.identity.firstName}

                        <span>
                            {profileInfosData.identity.lastName}
                        </span>

                    </h1>


                    <p className="profil-role">
                        {profileInfosData.identity.role}
                    </p>

                </div>

            </div>


            {/* =================================================
                SERVICES TITLE
                ================================================= */}

            <div className="profil-services-hero">

                <div className="profil-services-heading">

                    <span className="profil-tag">
                        EXPERTISE
                    </span>


                    <h2
                        id="profil-services-title"
                        className="profil-main-title"
                    >
                        SERVICES PROPOSÉS
                    </h2>

                </div>


                <div className="profil-services-count">

                    <strong>
                        10
                    </strong>

                    <span>
                        DOMAINES
                    </span>

                </div>

            </div>

        </header>


        {/* =====================================================
            TICKER
            ===================================================== */}

        <TickerBanner />


        {/* =====================================================
            PROFILE
            ===================================================== */}

        <section className="profil-manifesto-band">

            <ProfileManifesto />

            <ProfileLinks />

        </section>


        {/* =====================================================
            SERVICES
            ===================================================== */}

        <main className="profil-services">

            <div
                className="profil-services-grid"
                role="region"
                aria-label="Services proposés"
            >

                {servicesData.map(
                    (service, index) => (

                        <ServiceCard
                            key={service.title}
                            service={service}
                            index={index}
                        />

                    )
                )}

            </div>

        </main>

    </section>

);


export default Profil;